function formatPercentage(percentage: number): number {
  return percentage * 100;
}

export function getPercentageDifference(
  current: string | number,
  newCost: string | number,
): number {
  if (current === newCost) return 0;

  const [currentCost, newCostAsNumber] = [current, newCost].map(Number);

  if (!currentCost) return 0;

  if (currentCost < newCostAsNumber)
    return formatPercentage((newCostAsNumber - currentCost) / currentCost);

  return formatPercentage((currentCost - newCostAsNumber) / currentCost) * -1;
}
